<!--
 * @author: JJ
 * @since: 2024-10-09
 * mainTab.vue
-->
<template>
    <div class="main_tab">
        <div class="w1440 h55 flex-box">
            <div class="left"></div>
            <div class="flex-grow-1 flex">
                <div class="tab_parent" v-for="(item, index) in tab" :key="index"
                    @mouseleave="showFirst = false, move()"
                    @mouseenter="index == 1 ? (showFirst = true, lindex = 1, stop()) : ''">
                    <div class="tab_item" :class="nindex == index ? 'ac' : ''" @click="chooseNav(index, item.url)">
                        {{ item.name }}</div>
                </div>
            </div>
            <div class="right flex-box flex-center fs14" :style="{'color':color}">
                <img :src="phone" class="ico25" alt="">
                <div class="pl10">联系我们：</div>
                <div class="fwb">{{tel}}</div>
            </div>
        </div>
        <!--  -->
        <div class="popup" v-if="showFirst && lindex == 1">
            <div class="moudle" @click="closePopup" @mouseenter="showFirst = false, move()"></div>
            <div class="main fs16 scroll" ref="firstPopover" @mouseenter="showFirst = true, stop()">
                <div class="w1440 flex flex-start ">
                    <div class="flex mous3 lh20 fwb zpointer w100" @click="toProduct(0, -1, 0, 0)">
                        <div>热门产品</div>
                        <img src="../assets/static/icon/jj_hot.png" class=" hot" alt="">
                    </div>
                    <div class="pl180">
                        <div class="w20 m-ellipsis" v-for="(item, index) in categoryList" :key="index">
                            <div class="fwb mous3 lh20 pb5 zpointer" @click="toProduct(item.id, index, 0, -1)">{{
                                item.name }}</div>
                            <template v-for="(items, indexs) in item.children" :key="indexs">
                                <div class="disp mt20 fs14 lh18 cursor mous"
                                    @click="toProduct(item.id, index, items.id, indexs)">{{ items.name }}</div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        nindex: { type: Number, default: -1 },
        color: { type: String, default: '#3D7EFE' },
        phone: { type: String, default: require('../assets/static/icon/jj_phone_new.png') },
    },
    data() {
        return {
            lindex: 0,
            showFirst: false,
            firstPopover: null,
            tab: [{ name: '首页', url: '/' }, { name: '产品商城', url: '/FindProduct' }, { name: '活动中心', url: '/activities' }, { name: '优选品牌', url: '/brandshow' }, { name: '关于我们', url: '/Cooperate' }],
            list: [
                {
                    title: '注射',
                    list: ['玻尿酸', '胶原类', '再生类']
                },
                {
                    title: '假体',
                    list: ['胸假体', '鼻假体', '下巴假体', '太阳穴假体', '臀假体']
                },
                {
                    title: '线材',
                    list: ['PDO', 'PLLA', 'PCL']
                },
                {
                    title: '水光',
                    list: ['基础水光', '动能素水光', '胶原水光']
                },
                {
                    title: '耗材',
                    list: ['注射器', '针头']
                },
            ],
            tel:'',
            categoryList: [{
                children: []
            }],
        };
    },
    methods: {
        closePopup() {
            this.showFirst = false
        },
        //禁止滚动-在显示遮罩层的时候调用
        // stop() {
        //     document.body.style.overflow = 'hidden';
        //     // 添加滚轮事件监听器
        //     window.addEventListener('wheel', this.preventScroll, { passive: false });
        // },
        // 取消滑动限制-在关闭遮罩层的时候调用
        // move() {
        //     document.body.style.overflow = '';//出现滚动条
        //     // 移除滚轮事件监听器
        //     window.removeEventListener('wheel', this.preventScroll, { passive: true });
        // },
        // preventScroll(event) {
        //     event.preventDefault(); // 阻止默认滚动行为
        // },
        togglesPop() {
            this.showFirst = !this.showFirst;
            if (this.showFirst) {
                this.stop()
            } else {
                this.move()
            }
        },
        chooseNav(index, url) {
            this.lindex = index;
            if (index == 1) {
                this.$router.push({ path: url, query: { first_category_index: -2 } });
                this.showFirst = false;
                this.move()
                return
            }
            this.$router.push(url);
            this.showFirst = false;
            this.move()
        },
        toProduct(first_category_id, first_category_index, category_id, category_index) {
            this.$router.push({ path: "/FindProduct", query: { first_category_id, first_category_index, category_id, category_index } });
            this.showFirst = false;
            this.move()
        },
        // 获取分类
        getCategoryList() {
            this.$api.GetCategoryList().then(res => {
                if (res.code == 1) {
                    this.categoryList = res.data;
                }
            })
        },
    },
    beforeUnmount() {
        this.$bus.off('initSuccess');
    },
    created() {
        this.getCategoryList();
        this.tel = this.$root.$data.config.app.tel;
        this.$bus.on("initSuccess", () => {
            let config = this.$root.$data.config.app;
            //this.qrcode = config.customer_qrcode;
            this.tel = config.tel;
        });
    }
};
</script>
<style lang="less" scoped>
.h55 {
    height: 55px;
}

.tab_parent {
    height: 55px;
    display: flex;
    align-items: center;
}

.left {
    width: 268px;
}

.right {
    width: 290px;
    height: 55px;
    position: relative;
    z-index: 2;
}

.main_tab {
   width: 100%;
    height: 55px;
    background: #F9F9F9;
    position: relative;


    .tab_item {
        padding-left: 15px;
        padding-right: 15px;
        line-height: 55px;
        text-align: center;
        font-size: 18px;
        color: #272727;
        margin-right: 40px;
        cursor: pointer;
        position: relative;

        &.ac {
            color: #3D7EFE;
        }

        &.ac::after {
            content: '';
            width: 24px;
            height: 10px;
            background-position: 50% 50%;
            background-repeat: no-repeat;
            background-size: cover;
            background-image: url('../assets/static/icon/tab_i.png');
            position: absolute;
            left: 50%;
            bottom: 5px;
            transform: translateX(-50%);
        }
    }

    .tab_parent:hover {
        .tab_item {
            color: #3D7EFE;
        }

        .tab_item::after {
            content: '';
            width: 24px;
            height: 10px;
            background-position: 50% 50%;
            background-repeat: no-repeat;
            background-size: cover;
            background-image: url('../assets/static/icon/tab_i.png');
            position: absolute;
            left: 50%;
            bottom: 5px;
            transform: translateX(-50%);
        }
    }


    .ico25 {
        width: 25px;
        height: auto;
    }
}

.popup {
    position: absolute;
    height: calc(100vh - 55px - 58px - 150px);
    top: 55px;
    left: 0;
    right: 0;
    z-index: 99;

    .w100 {
        width: 220px;
    }

    .moudle {
        width: 100%;
        position: absolute;
        height: calc(100vh - 55px - 58px);
        background: rgba(86, 86, 86, 0.4);
        backdrop-filter: blur(2px);
        top: 0;
        left: 0;
        z-index: 2;
    }
}

.main {
    // width: 1920px;
    padding-top: 30px;
    padding-bottom: 45px;
    background: #FFFFFF;
    position: relative;
    z-index: 3;
    height: 328px;
    
}

.mous {
    color: #626262;
}

.mous:hover {
    color: #3D7EFE;
}
.mous3 {
    color: #333;
}
.mous3:hover {
    color: #3D7EFE;
}
.hot {
    margin-left: 15px;
    width: 54px;
    height: 24px;
    // margin-top: 0.02rem;
}

.pr183 {
    padding-right: 183px;
}

.w20 {
    // width: 260px;
    width: 220px;
    display: inline-block;
    vertical-align: top;
    // margin-top: 40px;
}

// .w20:nth-of-type(5n) {
//     width: auto;
// }
// .w20:nth-of-type(-n+5){margin-top: 0;}
.disp {
    display: block;
}

.w1200 {
    width: 1200px;
}

.pl180 {
    overflow-x: hidden;
    white-space: nowrap;
    max-width: 1200px;
    height: 100%;
    display: block;
    flex-shrink: 0;
}
.scroll{
    overflow-y: scroll;
    height: 100%;
    width: 100%;
}
</style>
